import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=029e9c19&scoped=true&"
import script from "./NewsDetail.vue?vue&type=script&lang=ts&"
export * from "./NewsDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029e9c19",
  null
  
)

export default component.exports